// extracted by mini-css-extract-plugin
export default {"root":"textarea_root__JlFht","input":"textarea_input__rDNPT","user":"textarea_user__QhRF8","editor":"textarea_editor__we43+","error":"textarea_error__PqAFD"};